<template>
<div class="chapter">
<div class="inner_page">
<div class="iosnode"><h1 class="part-number" id="A-157758_29">Part 1</h1>
<h1 class="part-title" id="A-157758_33">The Basics of Tarot</h1></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// N157758.vue?a9fde598